import { render, staticRenderFns } from "./BrandNews.vue?vue&type=template&id=0e8ddf9f&scoped=true&"
import script from "./BrandNews.vue?vue&type=script&lang=js&"
export * from "./BrandNews.vue?vue&type=script&lang=js&"
import style0 from "./BrandNews.vue?vue&type=style&index=0&id=0e8ddf9f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8ddf9f",
  null
  
)

export default component.exports